<template>
    <div class="print-container">
        <div v-if="loading" class="text-center mt-5">
            Loading QR Codes...
        </div>
        <div v-else class="qr-grid">
            <div v-for="modem in modems" :key="modem.id" class="qr-card">
                <img :src="qrImages[modem.kode]" alt="QR Code" width="150" height="150" v-if="qrImages[modem.kode]" />
                <div v-else style="width: 150px; height: 150px; display: flex; align-items: center; justify-content: center;">Loading...</div>
                <div class="kode-text">{{ modem.kode }}</div>
                <div class="merek-text">{{ modem.merek }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
    data() {
        return {
            modems: [],
            loading: true,
            qrImages: {},
            imagesProcessed: 0
        }
    },
    methods: {
        generateQRCodes() {
            const logoImage = new Image();
            logoImage.src = '/images/logo-bg.png';
            logoImage.onload = () => {
                this.modems.forEach(modem => {
                    const canvas = document.createElement('canvas');
                    QRCode.toCanvas(canvas, modem.kode, { 
                        errorCorrectionLevel: 'H',
                        margin: 1,
                        width: 150
                    }, (error) => {
                        if (error) console.error(error);
                        
                        const ctx = canvas.getContext('2d');
                        const size = canvas.width;
                        const logoSize = size * 0.25; 
                        const x = (size - logoSize) / 2;
                        const y = (size - logoSize) / 2;
                        
                        ctx.save();
                        ctx.beginPath();
                        // Gambar bulat putih sebagai background (sedikit lebih besar dari logo jika ingin border)
                        ctx.arc(x + logoSize / 2, y + logoSize / 2, logoSize / 2, 0, Math.PI * 2, true);
                        ctx.closePath();
                        ctx.fillStyle = 'white';
                        ctx.fill();
                        
                        // Kliping untuk membulatkan gambar logo
                        ctx.clip();
                        ctx.drawImage(logoImage, x, y, logoSize, logoSize);
                        ctx.restore();
                        
                        this.$set(this.qrImages, modem.kode, canvas.toDataURL('image/png'));
                        this.imagesProcessed++;
                        
                        if (this.imagesProcessed === this.modems.length) {
                            setTimeout(() => window.print(), 500);
                        }
                    });
                });
            };
            logoImage.onerror = () => {
                this.modems.forEach(modem => {
                    const canvas = document.createElement('canvas');
                    QRCode.toCanvas(canvas, modem.kode, { 
                        errorCorrectionLevel: 'H', margin: 1, width: 150
                    }, (error) => {
                        this.$set(this.qrImages, modem.kode, canvas.toDataURL('image/png'));
                        this.imagesProcessed++;
                        if (this.imagesProcessed === this.modems.length) {
                            setTimeout(() => window.print(), 500);
                        }
                    });
                });
            };
        }
    },
    mounted() {
        const ids = this.$route.query.ids;
        if (!ids) {
            alert('Tidak ada modem yang dipilih.');
            return;
        }
        
        axios.get('/api/modem', {
            params: { ids: ids, per_page: 999 }
        }).then(({ data }) => {
            this.modems = data.data.data;
            this.loading = false;
            this.$nextTick(() => {
                this.generateQRCodes();
            });
        }).catch(err => {
            console.error(err);
            this.loading = false;
        });
    }
}
</script>

<style scoped>
@media screen {
    .print-container {
        padding: 20px;
        background: #fff;
    }
}
@media print {
    body * {
        visibility: hidden;
    }
    .print-container, .print-container * {
        visibility: visible;
    }
    .print-container {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
    }
    /* Hide the navbar/sidebar manually if still visible */
    #sidebar, .main-header, .main-sidebar {
        display: none !important;
    }
}

.qr-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: flex-start;
}
.qr-card {
    text-align: center;
    border: 1px dashed #ccc;
    padding: 10px;
    width: 170px;
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    page-break-inside: avoid;
}
.kode-text {
    font-weight: bold;
    font-size: 14px;
    margin-top: 5px;
}
.merek-text {
    font-size: 12px;
    color: #666;
}
</style>
